import React from "react";

const Contact = ({ contact }) => (
  <div style={{ display: "flex", marginBottom: 20 }}>
    <div
      style={{
        width: 4,
        backgroundColor: "#f0f0f0",
        marginRight: 5
      }}
    ></div>
    <div>
      <div>
        <b>Fonction </b>: {contact.role}
      </div>
      <div>
        <b>Nom </b>: {contact.name}
      </div>
      <div>
        <b>Téléphone </b>: {contact.phone}
      </div>
      <div>
        <b>Mail </b>: {contact.email}
      </div>
    </div>
  </div>
);

export default Contact;



// WEBPACK FOOTER //
// src/components/contact/Contact.component.js